import { mapGetters } from "vuex";
import { USER_PROFILE } from "@/core/services/store/profile.module";
import {
    ROLE,
    HR_DEPARTMENT_IDS,
    DEPARTMENT_HR,
    TEAM_LEAD_ACCOUNT_TYPE_ID,
} from "@/core/config/teamLeadsCalendar/teamLeadsCalendarOption";

/**
 * Mixin xác định vai trò người dùng cho các trang "Lịch Teamlead".
 *
 * Route đã được chặn bằng quyền `lich-team-lead` và backend vẫn tự kiểm tra lại
 * theo department_id / account_type_id (xem API_CONTRACT.md). Vì vậy khi FE không
 * nhận diện được người dùng là Teamlead thì mặc định coi như HR (`effectiveRole`)
 * thay vì khoá im giao diện.
 */
export default {
    data() {
        return { profileDepartmentIds: [] };
    },
    computed: {
        ...mapGetters(["currentUser"]),
        currentUserId() {
            return this.currentUser && this.currentUser.id;
        },
        myAccountTypeId() {
            const u = this.currentUser || {};
            return (u.profile && u.profile.account_type_id) || (u.account_type && u.account_type.id) || null;
        },
        myDepartmentIds() {
            const ids = new Set((this.profileDepartmentIds || []).map(Number));
            this.resolveDepartmentIds(this.currentUser).forEach((id) => ids.add(Number(id)));
            return [...ids].filter(Boolean);
        },
        isHrDepartment() {
            return this.myDepartmentIds.includes(DEPARTMENT_HR);
        },
        isHr() {
            return this.myDepartmentIds.some((id) => HR_DEPARTMENT_IDS.includes(id));
        },
        isTeamLead() {
            return Number(this.myAccountTypeId) === TEAM_LEAD_ACCOUNT_TYPE_ID;
        },
        role() {
            if (this.isHr) return ROLE.HR;
            if (this.isTeamLead) return ROLE.TEAM_LEAD;
            return ROLE.VIEWER;
        },
        roleMeta() {
            return {
                [ROLE.HR]: { label: "HR — điều phối lịch", icon: "el-icon-s-custom" },
                [ROLE.TEAM_LEAD]: { label: "Teamlead — lịch của tôi", icon: "el-icon-user-solid" },
                [ROLE.VIEWER]: { label: "Chế độ xem (chưa xác định HR/Teamlead)", icon: "el-icon-view" },
            }[this.role];
        },
        effectiveRole() {
            return this.role === ROLE.VIEWER ? ROLE.HR : this.role;
        },
    },
    methods: {
        resolveDepartmentIds(source) {
            const ids = new Set();
            const push = (v) => {
                const n = Number(v);
                if (n) ids.add(n);
            };
            if (!source || typeof source !== "object") return [];
            const ud = source && source.use_department;
            const digOne = (d) => {
                if (!d || typeof d !== "object") return;
                push(d.department_id);
                push(d.id);
                if (d.department) {
                    push(d.department.id);
                    push(d.department.department_id);
                    if (d.department.department) push(d.department.department.id);
                }
            };
            if (Array.isArray(ud)) ud.forEach(digOne);
            else digOne(ud);
            push(source && source.profile && source.profile.department_id);
            push(source && source.department_id);
            digOne(source && source.department);
            return [...ids];
        },
        loadProfileDepartment() {
            this.$store
                .dispatch(USER_PROFILE)
                .then((res) => {
                    const data = res && res.data ? res.data : res;
                    this.profileDepartmentIds = this.resolveDepartmentIds(data);
                })
                .catch(() => {});
        },
    },
};
